import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx';

const EntryCoordinatorDetails = ({
  firstName,
  lastName,
  email,
  onEntryDetailCoordinatorUpdateClick
}) => (
  <Panel
    className="panel-primary"
    title="Coordinator Details"
    style={{}}>
    <div className="row">
      <div className="col-sm-12">
        <div className="form-group">
          <label>{firstName} {lastName}</label>
          <div>{email}</div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-12">
        <button
          type="submit"
          className="btn btn-link pull-right"
          onClick={() => onEntryDetailCoordinatorUpdateClick()}>
            {'Update'}
        </button>
      </div>
    </div>
  </Panel>
);

EntryCoordinatorDetails.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  onEntryDetailCoordinatorUpdateClick: PropTypes.func
};

EntryCoordinatorDetails.defaultProps = {
  firstName: '',
  lastName: '',
  email: ''
};

export default EntryCoordinatorDetails;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryCoordinatorDetail.jsx